window.ImagePicker = {
    listSelector: '#briefcaseContent ul.fileslist',
    loadMore: function(linkedtype, idSelected) {
        let offset = $(ImagePicker.listSelector).find('> li img').length;
        axios.get(`/rest/image-picker/list/${linkedtype}/${offset}`)
        .then(response => {
            if (!response.data.files.length) throw response
            response.data.files.forEach(file => {
                ImagePicker.addOneFile(file, idSelected)
            })
            if (!response.data.canHaveMoreFiles) {
                $('#seeMore').hide()
            }
        }).then(_ => {
            $(ImagePicker.listSelector).find('li')
            $('#imageForm').find('input[name=fileid]').val(idSelected);
            $('#imageForm').find('.chosen-filename').val($('#file-' + idSelected).find('.filename').text());

            $('.fileslist li:not(#file_' + idSelected + ')').removeClass('file-selected');
            $('#file_' + idSelected).addClass('file-selected');

        }).catch(_ => $('#seeMore').hide())
    },
    addOneFile: function(file) {
        $(ImagePicker.listSelector).append(`
<li id="file_${file.id}" onclick="CampaignForm.selectBriefcaseImage(${file.id});" class="well well-small m-1">
    <a href="javascript:;" onclick="BriefCaseV2Light.deleteIt(${file.id});" class="icon-trash"></a>
    <div class="preview">
        <img src="${file.public_url}" />
    </div>
    <div class="details">
        <span class="filename">
            <a href="javascript:;" title="${file.file_fullname}">${file.file_fullname}</a>
        </span>
    </div>    
</li>
        `)
        let li = document.createElement('li');
    }
};